export enum APIids {
  ERS = 'ERS',
}

export enum AppConfigParamsKeys {
  APP_ID = 'appid',
  DEFAULT_LATITUDE = 'lat',
  DEFAULT_LONGITUDE = 'lng',
  DEFAULT_ACCURACY = 'accuracy',
  PROD = 'prod',
  ZIP_CODE = 'memberzip',
  AGENT_FIRST_NAME = 'agent-first-name',
  AGENT_LAST_NAME = 'agent-last-name',
  COUNTRY = 'country',
  MAKE = 'make',
  MODEL = 'model',
  YEAR = 'year',
  FIRST_TIME_ACCESS = 'ft',
  CHANNEL = 'channel',
  DISTANCE_UNIT = 'distanceunit',
  ISSUE_TYPE = 'issuetype',
  // parameters for integration tests tweaks
  CALL_STATUS_INTERVAL = 'csi',
  SESSION_TIMEOUT_INTERVAL = 'sti',
  CHECK_SESSION_TIMEOUT_INTERVAL = 'csti',
  ALERT_SESSION_TIMEOUT_INTERVAL = 'asti',
  FIRST_CALL_STATUS_TIMEOUT = 'fcst',
  CREATE_CALL_TIMEOUT = 'cct',
  GET_ACTIVE_CALLS_TIMEOUT = 'gact',
  MOCK_CAPTCHA = 'mock-captcha',
  GET_PROPOSITIONS = 'getpropositions',
  ISSUE_LOADING_TIMER_CONFIG = 'iltc',
}

// TODO remove all ABTest parameters from UIConfigParamsKeys after the single abTest parameter is in use
export enum UIConfigParamsKeys {
  AB_TEST = 'abtest',
}

export enum AuthConfigParamsKeys {
  NAME_VALIDATE = 'namevalidate',
  MEM_ID = 'memid',
  ENCRYPTED_MEMBER_NUMBER = 'membernumber',
  ETS = 'ets',
  ORIGIN = 'origin',
  TOKEN = 'token',
  RAP_TOKEN = 'raptoken',
  ODOMETER = 'odometer',
  CLUB = 'club',
}
